// Indicador de estado con movimiento — cada estado dice lo que representa con su
// forma y su animación (§87b). Compartido entre «Estado del sistema» y el widget
// «Estado de fuentes» del panel de superadmin para que sean siempre idénticos.
//
//   ok       → latido ECG con un pulso que recorre la línea (vivo, con constantes)
//   warning  → triángulo de aviso con parpadeo (atención)
//   error    → triángulo en rojo con parpadeo (fallo)
//   pending  → spinner (esperando primera comprobación)
//   inactive → símbolo de apagado (power), gris y ESTÁTICO (no se vigila)
//
// Las keyframes (hx-ekg / hx-breathe / hx-spin) y el respeto a
// prefers-reduced-motion viven en index.css.

export const STATUS_COLORS: Record<string, string> = {
  ok:       "#16a34a",
  warning:  "#d97706",
  error:    "#dc2626",
  pending:  "#64748b",
  inactive: "#94a3b8",
};

export function StatusIcon({ status, size = 10, color: colorProp }: { status: string; size?: number; color?: string }) {
  // `color` opcional: páginas cliente con su propia paleta pueden pasar el suyo;
  // por defecto usa la paleta canónica.
  const color = colorProp ?? STATUS_COLORS[status] ?? STATUS_COLORS.inactive;

  if (status === "ok") {
    const d = "M1 8 H7 l2 -5 l2.6 10 l2.2 -6 H27";
    return (
      <svg width={size * 1.9} height={size} viewBox="0 0 28 16" fill="none"
        style={{ flexShrink: 0, overflow: "visible" }} aria-hidden>
        <path d={d} stroke={color} strokeOpacity={0.3} strokeWidth={1.8}
          strokeLinecap="round" strokeLinejoin="round" />
        <path className="hx-ekg" d={d} stroke={color} strokeWidth={2}
          strokeLinecap="round" strokeLinejoin="round"
          pathLength={100} strokeDasharray="20 80"
          style={{ animation: "hx-ekg 1.5s linear infinite" }} />
      </svg>
    );
  }

  if (status === "warning" || status === "error") {
    return (
      <svg className="hx-breathe" width={size + 3} height={size + 3} viewBox="0 0 24 24" fill="none"
        stroke={color} strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round"
        style={{ animation: "hx-breathe 1.5s ease-in-out infinite", flexShrink: 0 }} aria-hidden>
        <path d="M12 3 2 20h20L12 3z" /><path d="M12 10v4.5" /><path d="M12 17.5h.01" />
      </svg>
    );
  }

  if (status === "pending") {
    return (
      <svg className="hx-spin" width={size + 2} height={size + 2} viewBox="0 0 24 24" fill="none"
        stroke={color} strokeWidth={2.6} strokeLinecap="round"
        style={{ animation: "hx-spin 1.3s linear infinite", flexShrink: 0 }} aria-hidden>
        <path d="M21 12a9 9 0 1 1-6.2-8.6" />
      </svg>
    );
  }

  // inactive → apagado (power), gris y estático
  return (
    <svg width={size + 2} height={size + 2} viewBox="0 0 24 24" fill="none" stroke={color}
      strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }} aria-hidden>
      <path d="M12 2 v9" />
      <path d="M18.36 6.64 a9 9 0 1 1 -12.73 0" />
    </svg>
  );
}
